window.MapDrawing = {

  map: undefined,
  drawingManager: undefined,
  polygons: [],
  otherPolygons: {},
  info: undefined,

  createMap: function(center, zoom, input_container){
    this.input_container = input_container;
    this.polygonsColor = $('#mapForm').data('polygonsColor') || '#ff6900';
    this.info = document.querySelector('.carrier-info, .call-agent-map-info');

    this.map = new google.maps.Map(gMapDraw, {

      center: center,
      zoom: zoom,
      disableDefaultUI: true,
      zoomControl: true,
      scrollwheel: true,
      mapTypeControl: false,
      streetViewControl: false,
      disableDoubleClickZoom: true
    });

    var $inputs = $('#display_polygons input[type=checkbox]:not(#all_polygons)'),
        $allPolygons = $('#display_polygons #all_polygons')

    $inputs.change(function () {
      var $this = $(this),
          agentProfileId = $this.data('agentProfileId'),
          visible = $this.prop('checked'),
          checkedAll = $inputs.length === $inputs.filter(':checked').length

      $allPolygons.prop('checked', checkedAll)

      $.each(MapDrawing.otherPolygons[agentProfileId], function () {
        this.setOptions({visible: visible});
        this.marker.setOptions({visible: visible});
      });
    });
    $allPolygons.change(function () {
      $inputs.prop('checked', $(this).prop('checked')).trigger('change')
    })
  },
  createDrawingManager: function() {
    this.drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: null,
      drawingControl: false,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER
      },
      polygonOptions: {
        fillColor: this.polygonsColor,
        fillOpacity: 0.5,
        strokeWeight: 2,
        clickable: false,
        editable: false,
        zIndex: 1
      }
    });
    if (!this.info) this.setControlPanel();
    this.constructPolygon();
  },

  createInputPolygon: function(data){

    var input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('class', 'polygon-input');
    input.setAttribute('name', this.input_container + '[polygon_regions][][data]');
    input.setAttribute('value', data);

    return input;
  },
  addInputPolygon: function(input, parentDiv){
    parentDiv.append(input);
    return this;
  },
  clearInputPolygon: function(input){
    if (input) {
      if (input.value) {
        input.value = '';
      }
    }
  },
  getInputsPolygons: function(classInput){
    return $('.' + classInput);
  },
  parseInputValueToArray: function(string){
    return JSON.parse(string.replace(/\(/g, '[').replace(/\)/g, ']'));
  },
  parsePolygonArrayToString: function(array){
    var string = '';
    $.each(array, function(i, item){
      string += '(' + item.lat + ',' + item.lng + '),';
    }.bind(this));
    var resultString = '(' + string + ')';
    return resultString.replace(/,\)/, ')');
  },

  polygonPointsToPaths: function(points) {
    var polygonCoords = [];

    if (typeof points === 'string')
      points = MapDrawing.parseInputValueToArray(points);

    $.each(points, function(i, item){
      var obj;
      if (item.lat && item.lng) {
        obj = new google.maps.LatLng(item.lat, item.lng);
      } else {
        obj = new google.maps.LatLng(item[0], item[1]);
      }

      polygonCoords.push(obj);
    });

    return polygonCoords;
  },

  createPolygon: function(pointsArr, polygonId){
    if (!pointsArr) return;
    var id = polygonId;
    if (id === undefined) {
      id = $('.polygon-input').length;
    }

    var paths = this.polygonPointsToPaths(pointsArr);

    var polygon = new google.maps.Polygon({
      id: id,
      paths: paths,
      strokeWeight: 2,
      fillColor: this.polygonsColor,
      fillOpacity: 0.5,
      draggable: false,
      cursor: false,
      editable: false
    });

    polygon.marker = new google.maps.Marker({
      position: Functions.getUpperRightPoint(paths),
      map: this.map,
      icon: '/img/clear-button.png',
      visible: false
    });

    this.polygons.push(polygon);
    polygon.setMap(this.map);
    this.polygonComplete(polygon);

    google.maps.event.addListener(polygon.getPath(), 'set_at', this.updatePolygonInputs);
    google.maps.event.addListener(polygon.getPath(), 'insert_at', this.updatePolygonInputs);
  },

  renderOtherPolygons: function() {
    var self = this,
        otherPolygons = $('#mapForm').data('otherPolygons');
    for (var agentProfileId in otherPolygons) {
      var color = otherPolygons[agentProfileId].color || '#fefefe',
          polygonsArray = [];
      $.each(otherPolygons[agentProfileId].polygons, function() {
        var paths = self.polygonPointsToPaths(this);

        var polygon = new google.maps.Polygon({
          paths: paths,
          strokeWeight: 2,
          fillColor: color,
          fillOpacity: 0.3,
          draggable: false,
          cursor: false,
          editable: false
        });

        polygon.marker = new google.maps.Marker({
          position: Functions.getCenterPolygonPoint(paths),
          map: self.map,
          label: otherPolygons[agentProfileId].full_name,
          visible: true,
          icon: '/img/transparent-pixel.png'
          // Google API would render standard GMaps marker unless this .png provided
          // This marker created just for label
        });

        polygon.setMap(self.map);
        polygonsArray.push(polygon);
      });
      self.otherPolygons[agentProfileId] = polygonsArray;
    }
  },

  updatePolygonInputs: function() {
    $.each(MapDrawing.polygons, function() {
      var points = [],
          path = this.getPath();

      for (var i = 0; i < path.getLength(); i++) {
        var point = path.getAt(i);
        points.push({lat: point.lat(), lng: point.lng()});
      }
      var dataString = MapDrawing.parsePolygonArrayToString(points);

      if (this.visible) $('.polygon-input').eq(this.id).val(dataString)
    });
  },

  polygonComplete: function(polygonObj){
    var polygon = polygonObj;
    var _flagMarker = false;

    if (!this.info) {
      polygon.addListener('mouseover', polygonOver);
      polygon.addListener('mouseout', polygonOut);
    }
    function polygonOver(){

      polygon.marker.setOptions({visible: true});

      polygon.marker.addListener('mouseover', function(){
        _flagMarker = true;
      });
      polygon.marker.addListener('mouseout', function(){
        _flagMarker = false;
        polygon.marker.setOptions({visible: false});
      });
      polygon.marker.addListener('click', function(){

        polygon.marker.setOptions({visible: false});
        polygon.setMap(null);
        polygon.visible = false
        $('.polygon-input')[polygon.id].value = '';

      });
    }

    function polygonOut(){
      setTimeout(function(){
        if (!_flagMarker) {
          polygon.marker.setOptions({visible: false});
        }
      }, 400);
    }

    $('#drag_map').trigger('click');
  },

  drawPolygonFromInputs: function(classInput){

    var inputsArr = this.getInputsPolygons(classInput);

    $.each(inputsArr, function(i, item){
      if (!item.value) return;
      item.inputId = i;
      var points = this.parseInputValueToArray(item.value);
      this.createPolygon(points, i);

    }.bind(this));

    this.renderOtherPolygons();
  },

  deleteThisPolygon: function(arr){
    var input = $('.polygon-input');

    $.each(arr, function(i, item){
      if (!item.U) {
        console.warn(input[i]);
      }
    });
  },

  setControlPanel: function(){
    var self = this;
    var asd = document.getElementById('custom_control');
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(asd);

    var dragBtn = $('#drag_map');
    var drawBtn = $('#draw_shape');

    function touchStopScroll(e) {
      e.preventDefault();
    }

    function dragHandler() {
      self.setState('drag');
      self.setPolygonsEditable(false);
      if (self.isTouch()) {
        document.removeEventListener('touchmove', touchStopScroll);
        document.body.style.overflow = 'auto';
      }
      drawBtn.find('i').removeClass('active');
      dragBtn.find('i').addClass('active');
      self.drawingManager.setOptions({drawingMode: null});
      self.map.setOptions({draggable: true});
    }
    function drawHandler() {
      self.setState('draw');
      self.setPolygonsEditable(true);
      if (self.isTouch()) {
        document.addEventListener('touchmove', touchStopScroll,  { passive: false });
        document.body.style.overflow = 'hidden';
      }
      dragBtn.find('i').removeClass('active');
      drawBtn.find('i').addClass('active');
      self.drawingManager.setOptions({drawingMode: null});
      self.map.setOptions({draggable: false});
    }
    function clearHandler() {
      $.each(self.polygons, function(i, item){
        item.visible = false;
        item.setMap(self.map);
        self.clearInputPolygon($('.polygon-input')[i]);
      });
      dragBtn.click();
    }

    dragBtn.on('touchstart click', dragHandler);
    drawBtn.on('touchstart click', drawHandler);
    $('#clear_shapes').on('touchstart click', clearHandler);

    dragBtn.click();
  },

  constructPolygon: function() {
    var self = this
    let mouseDown = false
    let shapePoints = new google.maps.Polyline({})
    let startEvent = self.isTouch() ? 'touchstart' : 'mousedown'
    let endEvent = self.isTouch() ? 'touchend' : 'mouseup'

    google.maps.event.addDomListener(window, startEvent, function (event) {
      if (self.getState() !== 'draw') return;
      mouseDown = true
      shapePoints.setPath([])
      shapePoints.setMap(self.map)
    });

    this.map.addListener('mousemove', function(e) {
      if (self.getState() !== 'draw') return;
      if (!mouseDown) return;

      const path = shapePoints.getPath().getArray()
      path.push(e.latLng)
      shapePoints.setPath(path)
    });

    google.maps.event.addDomListener(window, endEvent, function (event) {
      try {
        if (self.getState() !== 'draw') return
        if (shapePoints.getPath().getArray().length === 0) return

        const maxPoints = 40;
        const path = shapePoints
          .getPath()
          .getArray()
          .map(x => ({ lat: x.lat(), lng: x.lng() }))

        if (path.length > maxPoints) {
          var step = path.length / maxPoints;

          for (var i = maxPoints; i > 0; --i) {
            var from = Math.floor((i-1)*step);
            var to = Math.floor(i*step)-1;
            path.splice(from, to - from);
          }
        }

        var parentDiv = $('#mapForm');
        this.createPolygon(path);

        var dataString = this.parsePolygonArrayToString(path);
        var inputPolygon = this.createInputPolygon(dataString);

        if (inputPolygon.value && inputPolygon.value !== '()') {
          this.addInputPolygon(inputPolygon, parentDiv);
        }
      } finally {
        mouseDown = false
        shapePoints.setMap(null)
      }
    }.bind(this));

  },

  setState: function(str) {
    this._drawState = str;
  },

  getState: function() {
    return this._drawState;
  },

  setPolygonsEditable: function(editable) {
    $.each(this.polygons, function() {
      this.setOptions({editable: editable});
    });
  },

  isTouch: function() {
    return Functions.isMobileDevice();
  },

  setPolygonsColor: function() {
    if ($(this).attr('disabled')) return false;
    var color = this.value;
    MapDrawing.polygonsColor = color;
    $.each(MapDrawing.polygons, function() {
      this.setOptions({fillColor: color});
    });
  }
};
